import { render, staticRenderFns } from "./forwards.vue?vue&type=template&id=a075cf58&"
import script from "./forwards.vue?vue&type=script&lang=js&"
export * from "./forwards.vue?vue&type=script&lang=js&"
import style0 from "./forwards.vue?vue&type=style&index=0&id=a075cf58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports